import React from "react";
import ScheduleStaffMetricCards from "./ScheduleStaffMetricCards";

export default function ScheduleLiveStatsPanel({
  sectionId = "schedule-stats",
  loading,
  dashboardStats,
  title = "Summary",
  hint = "Live counts for your schedule entries on this page.",
}) {
  return (
    <section id={sectionId} className="user-builder-panel" style={{ scrollMarginTop: "2rem" }}>
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">{title}</h3>
        <p className="user-builder-panel__hint">{hint}</p>
      </div>
      <ScheduleStaffMetricCards loading={loading} dashboardStats={dashboardStats} />
    </section>
  );
}
